import { Injectable } from "@angular/core";

import { Subject } from "rxjs";

import { SnackbarData } from "src/app/models/snackbar/snackbar.model";

@Injectable({
  providedIn: "root",
})
export class SnackbarService {
  private snackbarSubject = new Subject<any>();
  public snackbarState = this.snackbarSubject.asObservable();

  constructor() {}

  show(snackbarData: SnackbarData) {
    const { message, type } = snackbarData;
    this.snackbarSubject.next({
      show: true,
      message,
      type,
    });
  }

  close() {
    this.snackbarSubject.next({ show: false });
  }
}
